<script setup lang="ts">
withDefaults(defineProps<{mascot?:boolean}>(),{mascot:false})
</script>
<template>
  <svg :viewBox="mascot?'0 0 160 176':'0 0 120 120'" :class="['bear-mark',{'bear-mascot':mascot}]" :role="mascot?undefined:'img'" :aria-hidden="mascot?'true':undefined" :aria-label="mascot?undefined:'小野熊标志'" focusable="false">
    <g v-if="mascot" class="bear-body">
      <ellipse cx="81" cy="139" rx="41" ry="33" fill="var(--bear-fur,#2774ef)"/>
      <ellipse cx="81" cy="144" rx="22" ry="24" fill="var(--bear-muzzle,#edf5ff)"/>
      <ellipse cx="49" cy="163" rx="22" ry="12" fill="var(--bear-fur,#2774ef)"/>
      <ellipse cx="111" cy="163" rx="22" ry="12" fill="var(--bear-fur,#2774ef)"/>
      <ellipse cx="43" cy="130" rx="15" ry="25" transform="rotate(22 43 130)" fill="var(--bear-fur,#2774ef)"/>
      <ellipse cx="129" cy="115" rx="15" ry="28" transform="rotate(35 129 115)" fill="var(--bear-fur,#2774ef)"/>
      <ellipse cx="138" cy="99" rx="8" ry="9" fill="var(--bear-muzzle,#edf5ff)"/>
    </g>
    <g :transform="mascot?'translate(16 3) scale(1.08)':''">
      <circle cx="26" cy="28" r="18" fill="var(--bear-fur,#2774ef)"/><circle cx="94" cy="28" r="18" fill="var(--bear-fur,#2774ef)"/>
      <circle cx="26" cy="28" r="10" fill="var(--bear-ear,#9acaff)"/><circle cx="94" cy="28" r="10" fill="var(--bear-ear,#9acaff)"/>
      <path d="M60 22C88 22 111 39 111 66C111 96 90 112 60 112C30 112 9 96 9 66C9 39 32 22 60 22Z" fill="var(--bear-fur,#2774ef)"/>
      <path d="M29 44Q36 36 45 36" fill="none" stroke="var(--bear-ear,#9acaff)" stroke-width="5" stroke-linecap="round"/>
      <ellipse cx="60" cy="84" rx="23" ry="20" fill="var(--bear-muzzle,#edf5ff)"/>
      <ellipse cx="40" cy="62" rx="4.5" ry="5.5" fill="var(--bear-eye,#fff)"/><ellipse cx="80" cy="62" rx="4.5" ry="5.5" fill="var(--bear-eye,#fff)"/>
      <path d="M53 77Q60 72 67 77Q65 84 60 85Q55 84 53 77Z" fill="var(--bear-nose,#2255af)"/>
      <path d="M60 85V88M52 89Q60 97 68 89" fill="none" stroke="var(--bear-nose,#2255af)" stroke-width="3" stroke-linecap="round"/>
      <ellipse cx="28" cy="77" rx="6" ry="3" fill="var(--bear-ear,#9acaff)"/><ellipse cx="92" cy="77" rx="6" ry="3" fill="var(--bear-ear,#9acaff)"/>
    </g>
  </svg>
</template>
